import { Middleware } from 'redux';

const middleware: Middleware[] = [];

export default middleware;
